var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2ZM8.71971 12.574C8.68454 13.4447 9.40982 14.0792 10.1934 13.992C10.9771 13.9048 11.4938 13.1097 11.6954 12.2671C11.8805 11.4932 12.3066 10.8499 13.0275 10.2635C14.3456 9.20399 15.1503 7.90547 14.9765 5.99207C14.7176 3.14233 12.4553 1.71626 9.48275 2.04698C7.29373 2.29052 5.52127 3.50134 5.03365 5.66875C4.82406 6.60036 5.62786 7.32826 6.49101 7.23223C7.18958 7.15451 7.68575 6.49263 8.15192 5.87077C8.2376 5.75648 8.32226 5.64354 8.40697 5.53583C8.73247 5.122 9.20686 4.87397 9.71925 4.81696C10.7301 4.7045 11.6128 5.34649 11.7156 6.47824C11.8125 7.54486 11.1655 8.33237 10.3022 9.06991C9.16385 10.038 8.7746 11.2151 8.71971 12.574ZM11.9614 16.55C11.9614 17.5165 11.1779 18.3 10.2114 18.3C9.24493 18.3 8.46143 17.5165 8.46143 16.55C8.46143 15.5836 9.24493 14.8 10.2114 14.8C11.1779 14.8 11.9614 15.5836 11.9614 16.55Z",
    fill: "#2A2F35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarQuiz);
export default __webpack_public_path__ + "static/media/sidebarQuiz.40715ee4e23b1fe126387a9f9c44e5fa.svg";
export { ForwardRef as ReactComponent };